const selectFunderIdByCouchdbIdQuery = (couchdbId) => ({
  query: 'SELECT id FROM avocado.data_funder WHERE couchdb_id = $1',
  values: [couchdbId],
  queryName: 'selectFunderIdByCouchdbIdQuery'
})

const deleteFunderByCouchdbIdQuery = (couchdbId) => ({
  query: `
    DELETE FROM avocado.data_funder
    WHERE couchdb_id = $1
    RETURNING id
  `,
  values: [couchdbId],
  queryName: 'deleteFunderByCouchdbIdQuery'
})

const deleteFunderProgramPartnersByFunderIdQuery = (funderId) => ({
  query: `
    DELETE FROM avocado.data_funder_program_partner
    WHERE funder_id = $1
    RETURNING id
  `,
  values: [funderId],
  queryName: 'deleteFunderProgramPartnersByFunderIdQuery'
})

const updateChildFundersParentQuery = (parentFunderId, parentCouchdbId) => ({
  query: `
    UPDATE avocado.data_funder
    SET parent_funder_id = $1
    WHERE parent_funder_id IS NULL
      AND couchdb_id LIKE $2
  `,
  values: [parentFunderId, `funder:${String(parentCouchdbId).replace('funder:', '')}--%`],
  queryName: 'updateChildFundersParentQuery'
})

// Funders scoped to a set of program ids, via the funder<->program-partner
// mapping table, optionally narrowed further to an explicit funder allowlist
// (the user's `funders` list). Mirrors the scoping the legacy pouch
// `funders.list()` read applies.
//
// `funderId` narrows to a single funder in the same statement, so a `get` is one
// scoped row rather than `f.*` for every funder across the user's programs
// filtered down in JS.
//
// `funderId`/`funderIds` are matched against `couchdb_id`, i.e. the prefixed
// form (`funder:global-fund`) that a funder doc's `_id` and a user's `funders`
// allowlist both carry — not the `fsid` column, which for funders holds the
// prefix stripped off (see backend/.../sync-funder/model.ts).
const selectFundersByProgramsQuery = (programIds, { funderIds, funderId } = {}) => {
  const values = [programIds]
  const conditions = ['fpp.program_fsid = ANY($1)']

  if (funderIds && funderIds.length) {
    values.push(funderIds)
    conditions.push(`f.couchdb_id = ANY($${values.length})`)
  }

  if (funderId) {
    values.push(funderId)
    conditions.push(`f.couchdb_id = $${values.length}`)
  }

  return {
    query: `
      SELECT DISTINCT f.*
      FROM avocado.data_funder f
      INNER JOIN avocado.data_funder_program_partner fpp ON fpp.funder_id = f.id
      WHERE ${conditions.join('\n        AND ')}
    `,
    values,
    queryName: 'selectFundersByProgramsQuery'
  }
}

module.exports = {
  selectFunderIdByCouchdbIdQuery,
  deleteFunderByCouchdbIdQuery,
  deleteFunderProgramPartnersByFunderIdQuery,
  updateChildFundersParentQuery,
  selectFundersByProgramsQuery
}
